import { IOptionsWithTypes, SectionId } from "@eventr/common";
import { ColoursObj, Icon, MainButton } from "@eventr/common-storybook";
import { IconButton } from "@mui/material";
import { useSectionItemChat } from "feat/rocketchat/hooks/use-section-item-chat";
import i18n from "i18n/i18next";
import { enableChat } from "utils";

interface IChatButtonProps {
  names: string[];
  _id: string;
  editID?: string;
  users: IOptionsWithTypes[];
  sectionId?: SectionId;
  /** Offer Join to a viewer who is not a guest, and nothing to one who is. */
  joinOnly?: boolean;
}

export const ChatButton = ({
  names,
  users,
  _id,
  editID,
  sectionId = SectionId.ACTIVITY,
  joinOnly = false,
}: IChatButtonProps) => {
  const { state, isGuest, canJoin, isJoining, open, join } = useSectionItemChat({
    names,
    users,
    _id,
    editID,
    sectionId,
  });

  if (!enableChat()) return <div />;

  if (!isGuest) {
    return canJoin ? (
      <MainButton
        size="small"
        text={i18n.t("general.join")}
        icon="Add"
        disabled={isJoining}
        loading={isJoining}
        onClick={(e) => {
          e.stopPropagation();
          join();
        }}
      />
    ) : (
      <div />
    );
  }

  if (joinOnly || state === "hidden") return null;

  return (
    <IconButton
      onClick={(e) => {
        e.stopPropagation();
        open();
      }}
    >
      {state === "unread" ? (
        <Icon name="Chat_Notf" />
      ) : (
        state !== "loading" && (
          <Icon name="Chat" iconColour={state === "read" ? ColoursObj.core.primary : ColoursObj.shades.shade2} />
        )
      )}
    </IconButton>
  );
};
